// extracted by mini-css-extract-plugin
export default {"title":"Loading_title__hpUPe","text":"Loading_text__heC-P","imageContainer":"Loading_imageContainer__IVSfu","indicator":"Loading_indicator__ln5NH","spin":"Loading_spin__grgdF"};